export default {"src":"/_next/static/media/mortgagechoice.1ec16eff.svg","height":112,"width":506,"blurWidth":0,"blurHeight":0};